import { api } from "#app/http/api";

interface OnboardingNotificationParams {
  email?: string;
  companyId?: string;
  s3Folder: string;
}

interface OnboardingErrorNotificationParams {
  email?: string;
  companyId?: string;
  error: string;
}

export const sendOnboardingUploadNotification = async ({
  email,
  companyId,
  s3Folder,
}: OnboardingNotificationParams): Promise<void> => {
  await api.notifications.onboardingUpload.mutation({
    body: {
      email,
      companyId,
      s3Folder,
    },
  });
};

export const sendOnboardingUploadErrorNotification = async ({
  email,
  companyId,
  error,
}: OnboardingErrorNotificationParams): Promise<void> => {
  try {
    await api.notifications.onboardingUploadError.mutation({
      body: {
        email,
        companyId,
        error,
      },
    });
  } catch (_error) {
    // Silently fail - notification is not critical for user experience
  }
};
